import logoWhite from "./img/logo.png";

function Footer({ onResetConsent }) {
  return (
    <>
      <section class="contact-section bg-black" id="contact">
        <div class="container px-4 px-lg-5">
          <div class="row gx-4 gx-lg-5">
            <div class="col-md-4 mb-3 mb-md-0">
              <div class="card py-4 h-100">
                <div class="card-body text-center">
                  <i class="fas fa-briefcase text-primary mb-2"></i>
                  <h4 class="text-uppercase m-0">Our services</h4>
                  <hr class="my-4 mx-auto" />
                  <div class="extra-small text-white-50">
                    Discover our full range of services we offer.
                  </div>
                  <a href="/services" class="btn btn-primary mt-3">
                    View Our Services
                  </a>
                </div>
              </div>
            </div>
            <div class="col-md-4 mb-3 mb-md-0">
              <div class="card py-4 h-100">
                <div class="card-body text-center">
                  <i class="fas fa-star text-primary mb-2"></i>
                  <h4 class="text-uppercase m-0">Why Choose Us</h4>
                  <hr class="my-4 mx-auto" />
                  <div class="extra-small text-white-50">
                    Trusted by individuals across the UK.
                  </div>
                  <a href="/about" class="btn btn-primary mt-3">
                    Learn More Now
                  </a>
                </div>
              </div>
            </div>
            <div class="col-md-4 mb-3 mb-md-0">
              <div class="card py-4 h-100">
                <div class="card-body text-center">
                  <i class="fas fa-rocket text-primary mb-2"></i>
                  <h4 class="text-uppercase m-0">Get Started</h4>
                  <hr class="my-4 mx-auto" />
                  <div class="extra-small text-white-50">
                    Ready to file your Capital Gains Tax easily?
                  </div>
                  <a
                    href="https://chatcgt.typeform.com/to/rUw4Egui"
                    target="_blank"
                    class="btn btn-primary mt-3"
                  >
                    Get Started Here
                  </a>
                </div>
              </div>
            </div>
          </div>
          {/* Social Media Section 
          <div class="social d-flex justify-content-center">
            <a class="mx-2" href="https://accountantsleicester.net/" target="_blank">
              <i class="fa-solid fa-code"></i>
            </a>
            <a class="mx-2" href="https://www.tiktok.com/@inspiredaccounting" target="_blank">
              <i class="fab fa-tiktok"></i>
            </a>
            <a class="mx-2" href="#!" target="_blank">
              <i class="fab fa-instagram"></i>
            </a>
          </div>
          */}
        </div>
      </section>

      <footer className="footer text-center py-4 mt-5">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center flex-column flex-md-row">
            <div className="mb-3 mb-md-0">
              <a href="/">

              <img
                style={{
                  height: "25px",
                  filter: "grayscale(100%) opacity(60%)",
                }}
                src={logoWhite}
                alt="ChatCGT Logo"
                />
                </a>
            </div>

            <div className="list-inline mb-0">
              <ul className="list-inline mb-0">
                <li className="list-inline-item">
                  <a href="/privacy-policy" className="footer-link">
                    Privacy Policy
                  </a>
                </li>
                <li className="list-inline-item mx-2">|</li>
                
                <li className="list-inline-item">
                  <a href="/cookie-policy" className="footer-link">
                    Cookie Policy
                  </a>
                </li>
                <li className="list-inline-item mx-2">|</li>
                <li className="list-inline-item">
                  <a className="footer-link" onClick={onResetConsent}>
                    Change Cookie Preferences
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <hr className="my-3" />
          <p className="footer-text mb-0">
            &copy; 2025 ChatCGT LTD. All rights reserved.
          </p>
        </div>
      </footer>
    </>
  );
}

export default Footer;
